export default "__VITE_ASSET__ecQ3I8HL__"